export default "__VITE_ASSET__B_Bj8B1i__"